import React from "react";
import "./resources.css";
import Footer from "../Footer";

const ApiReference = () => {
  return (
    <div className="resource-page">
      <div className="resource-container">
        <h1>API Reference</h1>
        <p className="resource-subtitle">
          KostPadi API access is currently available only to approved partners,
          integrations, and internal services.
        </p>

        <section className="resource-section">
          <h2>Current API Status</h2>
          <div className="resource-card full">
            <p>
              KostPadi currently uses secure internal APIs for authentication,
              company management, invoices, payments, accounting records,
              inventory, reports, AI assistant features, and billing.
            </p>

            <p>
              Public API access is not yet generally available. When released,
              API access will include authentication controls, rate limits,
              request logging, permission scopes, and data protection
              safeguards.
            </p>
          </div>
        </section>

        <section className="resource-section">
          <h2>Planned API Categories</h2>
          <div className="resource-grid">
            <div className="resource-card">
              <h3>Companies</h3>
              <p>Create, update, and retrieve company profile information.</p>
            </div>

            <div className="resource-card">
              <h3>Customers</h3>
              <p>Manage customer records and contact information.</p>
            </div>

            <div className="resource-card">
              <h3>Invoices</h3>
              <p>
                Create invoices, retrieve invoice history, and manage payment
                status.
              </p>
            </div>

            <div className="resource-card">
              <h3>Payments</h3>
              <p>Connect payment records to invoices and customer balances.</p>
            </div>

            <div className="resource-card">
              <h3>Reports</h3>
              <p>
                Access accounting reports such as income statement and trial
                balance.
              </p>
            </div>

            <div className="resource-card">
              <h3>Webhooks</h3>
              <p>
                Receive event notifications for payments, invoices, and
                subscriptions.
              </p>
            </div>
          </div>
        </section>

        <section className="resource-section">
          <h2>Integration Notice</h2>
          <div className="resource-card full">
            <p>
              Any API access involving customer data, financial data, or
              personal information must comply with KostPadi’s Privacy Policy,
              Data Processing terms, and applicable Nigerian data protection
              requirements.
            </p>
          </div>
        </section>
      </div>
      <Footer />
    </div>
  );
};

export default ApiReference;
